import { render, staticRenderFns } from "./TipologiaservizioFilter.vue?vue&type=template&id=403d486f&"
import script from "./TipologiaservizioFilter.vue?vue&type=script&lang=ts&"
export * from "./TipologiaservizioFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports